// extracted by mini-css-extract-plugin
module.exports = {"background":"style_background__lZNh1"};